module.exports = __webpack_public_path__ + "img/wljg005.8dc194a9.jpg";